import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import API from "../../redux/actions/API";
import { authHeader } from "../../functions/CoreFunctions";
import CustomButtonLoader from "../CustomComponents/CustomButtonLoader";
import { CustomAlertMessage } from "../../functions/CustomFunctions";
import { useSnackbar } from "notistack";
import { useNavigate, useParams } from "react-router-dom";
import { Container, Row, Col } from "reactstrap";
import CustomerUpdatePassword from "./CustomerUpdatePassword";
import CustomerSendOtp from "./CustomerSendOtp";
import HeaderLogo from "../common/HeaderLogo";
import { AGENCY_IDLOGO_URL } from "../../constants/ApiPaths";
import CustomPageLoading from "../CustomComponents/CustomPageLoading";
import { LandingPagePlansBlock } from "./UserSignin";

function CustomerForgetPassword(props) {
  let logagencyUrl;
  if (props.location.state) {
    let { agencyUrl } = props.location.state;
    logagencyUrl = agencyUrl;
  }
  const [flag, setFlag] = useState(true);
  const [loading, setLoading] = useState(false);
  const [reloading, setReLoading] = useState(false);
  const [agencyPlans, setAgencyPlans] = useState([]);
  const [pageloading, setPageLoading] = useState(true);
  let { agencyUrl } = useParams();
  const { enqueueSnackbar } = useSnackbar();
  const history = useNavigate();
  const [email, setEmail] = useState("");
  const getAgencyIdandLogo = async () => {
    const config = {
      method: "GET",
      url: AGENCY_IDLOGO_URL,
      headers: authHeader(),
      params: { agencyUrl: agencyUrl },
    };
    try {
      const response = await API(config);
      const {
        status,
        data,
        agencyId,
        agencyLogo,
      } = response.data;
      localStorage.setItem("LOGGED_AGENCY_ID", agencyId);
      localStorage.setItem("AGENCYLOGO", agencyLogo);

      if (status === "Success") {
        setAgencyPlans(data);
      } else if (status === "Error") {
      }
    } catch (error) {
      console.error(error);
    } finally {
      setPageLoading(false);
    }
  };
  useEffect(() => {
    getAgencyIdandLogo();
  }, [agencyUrl]);

  if (pageloading) {
    return <CustomPageLoading />;
  }
  return (
    <div>
      <HeaderLogo userIndex="userIndex" />
      <div className="urs-bg">
        <div className="urs-overlay"></div>
        <Container fluid>
          <Row className="align-items-center">
            <LandingPagePlansBlock agencyPlans={agencyPlans} />

            <Col lg="6" xl="4">
              <div className="urs-form">
                {flag ? (
                  <CustomerSendOtp
                    loading={loading}
                    setLoading={setLoading}
                    enqueueSnackbar={enqueueSnackbar}
                    setFlag={setFlag}
                    useFormik={useFormik}
                    Yup={Yup}
                    API={API}
                    authHeader={authHeader}
                    CustomButtonLoader={CustomButtonLoader}
                    CustomAlertMessage={CustomAlertMessage}
                    setEmail={setEmail}
                    agencyUrl={logagencyUrl}
                  />
                ) : (
                  <CustomerUpdatePassword
                    loading={loading}
                    reloading={reloading}
                    setReLoading={setReLoading}
                    setLoading={setLoading}
                    enqueueSnackbar={enqueueSnackbar}
                    history={history}
                    useFormik={useFormik}
                    Yup={Yup}
                    API={API}
                    authHeader={authHeader}
                    email={email}
                    CustomButtonLoader={CustomButtonLoader}
                    CustomAlertMessage={CustomAlertMessage}
                    agencyUrl={logagencyUrl}
                  />
                )}
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
}

export default CustomerForgetPassword;
